import { CSSProperties } from 'react';
import { isWeb } from 'tamagui';

/**
 * Cursor is a web-only affordance — passing it on native leaks to the RN host
 * node. `isWeb` is a module-load constant, so this is safe to call inside a
 * static styled-variant definition. Mirrors the kit's internal `webCursor`,
 * which is not exported from `@knitui/components`.
 */
export const webCursor = (cursor: CSSProperties['cursor']) => (isWeb ? { cursor } : {});
